class CollectionFilters {
  constructor() {
    this.elements = this.cacheElements();

    if (!this.elements.drawer) return;

    this.bindEvents();
  }

  cacheElements() {
    this.root = document.querySelector(".collection-filters");

    return {
      openButtons: this.root?.querySelectorAll("[data-open-filter]"),
      drawer: this.root?.querySelector(".collection-filters-drawer"),
      overlay: this.root?.querySelector(".collection-filters-overlay"),
      closeButton: this.root?.querySelector(".collection-filters-close"),
      sizeButtons: this.root?.querySelectorAll(".filter-size-button"),
      colorCheckboxes: this.root?.querySelectorAll(".filter-color-checkbox"),

      accordions: this.root?.querySelectorAll(".filter-accordion"),
      accordionTriggers: this.root?.querySelectorAll(
        ".filter-accordion-trigger",
      ),
    };
  }

  bindEvents() {
    this.elements.openButtons.forEach((button) => {
      button.addEventListener("click", () => {
        this.openDrawer(button.dataset.openFilter);
      });
    });

    this.elements.closeButton?.addEventListener("click", () => {
      this.closeDrawer();
    });

    this.elements.overlay?.addEventListener("click", () => {
      this.closeDrawer();
    });

    this.bindAccordionEvents();

    this.bindFilterEvents();
  }

  bindAccordionEvents() {
    this.elements.accordionTriggers.forEach((trigger) => {
      trigger.addEventListener("click", () => {
        this.toggleAccordion(trigger);
      });
    });
  }

  bindFilterEvents() {
    this.elements.sizeButtons.forEach((button) => {
      button.addEventListener("click", () => {
        this.applyFilter(button);
      });
    });

    this.elements.colorCheckboxes.forEach((checkbox) => {
      checkbox.addEventListener("change", () => {
        this.applyFilter(checkbox);
      });
    });
  }

  openDrawer(filter) {
    if (filter === "all") {
      this.elements.overlay.classList.remove("hidden");
      this.elements.drawer.classList.remove("-translate-x-full");
    } else {
      const accordion = document.querySelector(`[data-accordion=${filter}]`);
      const content = accordion.querySelector(".filter-accordion-content");

      this.elements.overlay.classList.remove("hidden");
      content.classList.remove("hidden");
      this.elements.drawer.classList.remove("-translate-x-full");
    }
  }

  closeDrawer() {
    const contents = document.querySelectorAll(".filter-accordion-content");

    contents.forEach((content) => {
      content.classList.add("hidden");
    });

    this.elements.overlay.classList.add("hidden");

    this.elements.drawer.classList.add("-translate-x-full");
  }

  toggleAccordion(trigger) {
    const accordion = trigger.closest(".filter-accordion");

    const content = accordion.querySelector(".filter-accordion-content");

    const icon = accordion.querySelector(".accordion-icon");

    content.classList.toggle("hidden");

    icon.classList.toggle("rotate-180");
  }

  updateFilterCount() {
    const activeFilters = this.root.querySelectorAll("[data-active='true']");

    const count = activeFilters.length;

    const badge = this.root.querySelector(".collection-filter-count");

    badge.textContent = `(${count})`;

    badge.classList.toggle("hidden", count === 0);
  }

  restoreDrawerState(openAccordions) {
    this.elements.overlay.classList.remove("hidden");
    this.elements.drawer.classList.remove("-translate-x-full");

    openAccordions.forEach((name) => {
      const accordion = this.elements.drawer.querySelector(
        `[data-accordion="${name}"]`,
      );

      if (!accordion) return;

      accordion
        .querySelector(".filter-accordion-content")
        .classList.remove("hidden");

      accordion.querySelector(".accordion-icon").classList.add("rotate-180");
    });
  }

  async applyFilter(element) {
    const wasDrawerOpen =
      !this.elements.drawer.classList.contains("-translate-x-full");

    const openAccordions = [...document.querySelectorAll(".filter-accordion")]
      .filter((accordion) => {
        return !accordion
          .querySelector(".filter-accordion-content")
          .classList.contains("hidden");
      })
      .map((accordion) => accordion.dataset.accordion);

    const url =
      element.dataset.active === "true"
        ? element.dataset.urlRemove
        : element.dataset.urlAdd;

    if (!url) return;

    let html;

    // On a failed or rate-limited request, keep the grid that is on screen.
    try {
      const response = await fetch(url);

      if (!response.ok) return;

      html = await response.text();
    } catch (error) {
      return;
    }

    const parser = new DOMParser();

    const documentHTML = parser.parseFromString(html, "text/html");

    const products = documentHTML.querySelector("#CollectionProducts");

    const filters = documentHTML.querySelector("#CollectionFilters");

    if (!products) return;

    document.querySelector("#CollectionProducts")?.replaceWith(products);

    if (filters) {
      document.querySelector("#CollectionFilters")?.replaceWith(filters);
    }

    history.pushState({}, "", url);

    this.elements = this.cacheElements();

    this.bindEvents();

    this.updateFilterCount();

    if (wasDrawerOpen) {
      this.restoreDrawerState(openAccordions);
    }

    initProductCards();
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new CollectionFilters();
});
